import type { VideoSpeed } from "../../types/video";
import React, { useState } from "react";
import { Settings } from "lucide-react";

interface SpeedMenuProps {
  currentSpeed: VideoSpeed;
  onSpeedChange: (speed: VideoSpeed) => void;
}

const SPEEDS: VideoSpeed[] = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2];

export function SpeedMenu({ currentSpeed, onSpeedChange }: SpeedMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button onClick={() => setIsOpen(!isOpen)} className="p-2 hover:bg-white/20 rounded-full transition-colors flex items-center gap-1">
        <Settings className="w-5 h-5 text-white" />
        <span className="text-white text-xs">{currentSpeed}x</span>
      </button>

      {isOpen && (
        <div className="absolute bottom-full right-0 mb-2 bg-black/90 rounded-lg overflow-hidden min-w-[120px] z-50 shadow-lg">
          <div className="p-2 border-b border-white/10">
            <span className="text-white text-sm font-medium">Oynatma Hızı</span>
          </div>
          <div className="max-h-64 overflow-y-auto">
            {SPEEDS.map((speed) => (
              <button
                key={speed}
                onClick={() => {
                  onSpeedChange(speed);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                  speed === currentSpeed ? "bg-purple-600 text-white font-medium" : "text-white hover:bg-white/10"
                }`}>
                {speed}x{speed === 1 && " (Normal)"}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
